/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdAutoCompleteProps } from './type';

export const autoCompleteDefaultProps: TdAutoCompleteProps = {
  borderless: false,
  filterable: true,
  highlightKeyword: true,
  placeholder: undefined,
  size: 'medium',
  status: 'default',
};
